import axios from "axios";
import { API_BASE_URL } from "../environment";

export const getHrmDashboard = async (financer_id: number, period: string, user_type?: string, retailer_id?: number) =>
  (await axios.get(`${API_BASE_URL}/hrm/dashboard`, { params: { financer_id, period, user_type, retailer_id } })).data;
export const saveHrRecord = async (data: any) =>
  (await axios.post(`${API_BASE_URL}/hrm/record`, data)).data;
export const saveAttendance = async (financer_id: number, rows: any[]) =>
  (await axios.post(`${API_BASE_URL}/hrm/attendance/bulk`, { financer_id, rows })).data;
export const generatePayroll = async (financer_id: number, period: string, working_days: number) =>
  (await axios.post(`${API_BASE_URL}/hrm/payroll/generate`, { financer_id, period, working_days })).data;
export const updatePayrollStatus = async (id: number, data: any, financer_id: number) =>
  (await axios.patch(`${API_BASE_URL}/hrm/payroll/${id}/status`, data, { params: { financer_id } })).data;
